var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("dados-cartorio", {
        on: { atualizarListaCartorios: _vm.atualizarListaCartorios },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(scope) {
              return [
                _c("el-checkbox", {
                  staticClass: "input",
                  attrs: { label: 'Incluir solicitação de "Inteiro Teor"' },
                  on: { change: _vm.atualizaInteiroTeor },
                  model: {
                    value: _vm.isInteiroTeor,
                    callback: function($$v) {
                      _vm.isInteiroTeor = $$v
                    },
                    expression: "isInteiroTeor"
                  }
                })
              ]
            }
          }
        ])
      }),
      _vm.isInteiroTeor
        ? _c(
            "dados-oficio-inteiro-teor",
            _vm._g({ attrs: { dadosAnexos: _vm.dadosAnexos } }, _vm.$listeners)
          )
        : _vm._e(),
      _c("dados-processo", { attrs: { processo: _vm.processo } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-751f053e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-751f053e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/arrecadacao/cpat/components/oficio/InformarDados.vue
// module id = null
// module chunks = 